export default {
    drawer: null,
    drawerColor: 'white',
    appBarColor: 'red darken-2',
    loadingScreen: true
}
